var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/input/input.tsx";
const _excluded = ["type", "icon", "className", "outerClassName", "hasError", "addon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '../icon/icon';
import SvgIcon from '../icon/svg-icon';
import Tooltip from '../tooltip/tooltip';
const messages = defineMessages({
  showPassword: {
    "id": "input.password.show_password",
    "defaultMessage": "Show password"
  },
  hidePassword: {
    "id": "input.password.hide_password",
    "defaultMessage": "Hide password"
  }
});
/** Form input element. */
const Input = /*#__PURE__*/React.forwardRef((props, ref) => {
  const intl = useIntl();
  const {
      type = 'text',
      icon,
      className,
      outerClassName,
      hasError,
      addon
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  const [revealed, setRevealed] = React.useState(false);
  const isPassword = type === 'password';
  const togglePassword = React.useCallback(() => {
    setRevealed(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('mt-1 relative rounded-md shadow-sm', outerClassName),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }, icon ? /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: icon,
    className: "h-4 w-4 text-gray-400",
    "aria-hidden": "true",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 13
    }
  })) : null, addon ? /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }, addon) : null, /*#__PURE__*/React.createElement("input", _extends({}, filteredProps, {
    type: revealed ? 'text' : type,
    ref: ref,
    className: classNames({
      'dark:bg-slate-800 dark:text-white block w-full sm:text-sm border-gray-300 dark:border-gray-600 rounded-md focus:ring-primary-500 focus:border-primary-500': true,
      'pr-7': isPassword,
      'text-red-600 border-red-600': hasError,
      'pl-8': typeof icon !== 'undefined',
      'pl-16': typeof addon !== 'undefined'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  })), isPassword ? /*#__PURE__*/React.createElement(Tooltip, {
    text: revealed ? intl.formatMessage(messages.hidePassword) : intl.formatMessage(messages.showPassword),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: togglePassword,
    tabIndex: -1,
    className: "text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 h-full px-2 focus:ring-primary-500 focus:ring-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    src: revealed ? require('@tabler/icons/eye-off.svg') : require('@tabler/icons/eye.svg'),
    className: "h-4 w-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 17
    }
  })))) : null);
});
export default Input;